import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PublicRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  // Allow logged-in users to access the homepage without redirecting to the dashboard
  if (isLoggedIn && location.pathname === "/") {
    return children;
  }

  // Redirect to the dashboard if the user is logged in and not on the homepage
  return isLoggedIn ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;
